import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Redirect mappings: source path → target path
const redirects = {
  '/new-faq': '/supportkundeportal',
  '/el': '/elaftale',
  '/elaftale-b': '/elaftale',
  '/elaftale-kvartalsafregning': '/elaftale',
  '/ladeløsninger': '/opladere',
  '/charger/zaptec-go-2': '/zaptec-go-2',
  '/charger/nexblue-edge-2': '/nexblue-edge-2',
  '/solar': '/solcelleaftale',
  '/page': '/elpris-sammenligning',
  '/selvbetjening': '/supportkundeportal',
  '/terms': '/leveringsbetingelser',
  '/handelsbetingelser': '/leveringsbetingelser',
  '/privacy-policy': '/privatlivspolitik',
  '/cookie-policy': '/cookiepolitik',
  '/prices': '/gebyrer',
  '/fees': '/gebyrer',
  '/articles': '/blog',
  '/blog/artikler': '/blogartikler',
  '/blog/videoer': '/blogvideoer',
  '/blog/taenk-test': '/blogartikeltaenktest',
  '/blogartikel-taenk-test': '/blogartikeltaenktest',
  '/blog/elbiil-dk-test-enkel-energi-billigste': '/blogartikelelbiiltest',
  '/kundeservice': '/supportkundeportal',
  '/serviceaftale': '/service-aftale',
  '/m-elaftale': '/elaftale',
  '/m-opladere': '/opladere',
  '/m-laderabat': '/el-fordele#laderabat',
  '/m-serviceaftale': '/el-fordele#serviceaftale',
  '/articles/elbiil-dk-test-enkel-energi-billigste': '/blogartikelelbiiltest',
  '/articles/guide-til-el-lader-hjemme': '/blogartikelguideellader',
  '/articles/hvad-koster-installation-af-ladeboks': '/blogartikelinstallationpris',
  '/articles/smart-charge': '/portal/smart-charge',
  '/articles/refusion': '/blogartikelrefusion',
  '/articles/ladeboks': '/blogartikelladeboks',
  '/articles/bedste-ladestandere': '/blogartikelbedsteladestandere',
  '/articles/sammenligning': '/blogartikelsammenligning',
  '/articles/kan-alle-faa-stroem-fra-enkel': '/kan-alle-faa-stroem-fra-enkel',
  '/articles/virker-enkel-med-alle-ladebokse': '/virker-enkel-med-alle-ladebokse',
  '/articles/pris-time-for-time': '/pris-time-for-time',
  '/articles/forstaa-din-elregning': '/forstaa-din-elregning',
  '/articles/hvad-koster-el-gennem-enkel': '/hvad-koster-el-gennem-enkel',
  '/articles/er-enkel-klar-til-15-minutters-afregning': '/er-enkel-klar-til-15-minutters-afregning',
  '/articles/hvor-lang-tid-tager-det-at-skifte': '/hvor-lang-tid-tager-det-at-skifte',
  '/articles/skal-jeg-opsige-hos-mit-nuvaerende-elselskab': '/skal-jeg-opsige-hos-mit-nuvaerende-elselskab',
  '/articles/kan-jeg-koebe-ladeboks-uden-el-aftale': '/kan-jeg-koebe-ladeboks-uden-el-aftale',
  '/articles/hvilken-ladeboks-skal-jeg-vaelge': '/hvilken-ladeboks-skal-jeg-vaelge',
  // Old loesning pages → frontpage
  '/loesning': '/',
  '/loesning2': '/',
  '/ev-forside': '/',
  '/elbil': '/',
  // Service/feature pages → consolidated into /el-fordele
  // Saving Mode has ONE public page: /portal/smart-charge. Laderabat lives on the /el-fordele hub.
  // /service-aftale is intentionally NOT redirected – it stays reachable by direct link (CRM/email) but is noindex.
  '/smart-charge': '/portal/smart-charge',
  '/laderabat': '/el-fordele#laderabat',
  // Archived duplicates → their consolidated homes
  '/arkiv-smart-charge': '/portal/smart-charge',
  '/arkiv-laderabat': '/el-fordele#laderabat',
  '/arkiv-serviceaftale': '/el-fordele#serviceaftale',
  // Retired marketing pages → redirect to proper equivalents
  '/marketing-opladere': '/opladere',
  '/marketing-nexblue-edge-2': '/nexblue-edge-2',
  '/marketing-zaptec-go': '/zaptec-go',
  '/marketing-zaptec-go-2': '/zaptec-go-2',
  '/marketing-solcelle': '/solcelleaftale',
  '/marketing-nexblue-zen-stromsensor': '/nexblue-zen-stromsensor',
};

// Check if redirect exists and return target (used by NotFound page)
export function getRedirectTarget(path) {
  return redirects[decodeURIComponent(path).toLowerCase().replace(/\/$/, '')] || null;
}

export default function RedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = decodeURIComponent(location.pathname).toLowerCase().replace(/\/$/, '');
    const targetPath = redirects[currentPath];
    
    if (targetPath) {
      // Preserve query string
      // Preserve query string; targets may carry a #section anchor
      const [pathname, hash = ''] = targetPath.split('#');
      navigate({ pathname, search: location.search, hash: hash ? `#${hash}` : location.hash }, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}